import * as fromPolicy from "./policy";
import * as fromAuth from "./auth";
import * as fromRegistration from "./registration";
import * as fromOnlineRenewal from "./onlineRenewal";
import * as fromEnrolGIRONow from "./enrolGIRONow";
import * as fromTwilio from "./twilio";

//policy
export const getPaymentStatusMessageLoading = (state) =>
  fromPolicy.getPaymentStatusMessageLoading(state.policy);
export const getPaymentStatusMessage = (state) =>
  fromPolicy.getPaymentStatusMessage(state.policy);

export const getChatConfigurationLoading = (state) =>
  fromPolicy.getChatConfigurationLoading(state.policy);
export const getChatConfigurationData = (state) =>
  fromPolicy.getChatConfigurationData(state.policy);
export const getChatConfigurationStatus = (state) =>
  fromPolicy.getChatConfigurationStatus(state.policy);

export const getCreateChatLoading = (state) =>
  fromPolicy.getCreateChatLoading(state.policy);
export const getCreateChatData = (state) =>
  fromPolicy.getCreateChatData(state.policy);
export const getCreateChatStatus = (state) =>
  fromPolicy.getCreateChatStatus(state.policy);

export const getChatUpdateLoading = (state) =>
  fromPolicy.getChatUpdateLoading(state.policy);
export const getChatUpdateData = (state) =>
  fromPolicy.getChatUpdateData(state.policy);
export const getChatUpdateStatus = (state) =>
  fromPolicy.getChatUpdateStatus(state.policy);

export const getChatMessageLoading = (state) =>
  fromPolicy.getChatMessageLoading(state.policy);
export const getChatMessageData = (state) =>
  fromPolicy.getChatMessageData(state.policy);
export const getChatMessageStatus = (state) =>
  fromPolicy.getChatMessageStatus(state.policy);

export const getCreateMessageLoading = (state) =>
  fromPolicy.getCreateMessageLoading(state.policy);
export const getCreateMessageData = (state) =>
  fromPolicy.getCreateMessageData(state.policy);
export const getCreateMessageStatus = (state) =>
  fromPolicy.getCreateMessageStatus(state.policy);

export const getTwilioQuitQueueLoading = (state) =>
  fromPolicy.getTwilioQuitQueueLoading(state.policy);
export const getTwilioQuitQueueData = (state) =>
  fromPolicy.getTwilioQuitQueueData(state.policy);
export const getTwilioQuitQueueStatus = (state) =>
  fromPolicy.getTwilioQuitQueueStatus(state.policy);

export const getScheduleCallBackLoading = (state) =>
  fromPolicy.getScheduleCallBackLoading(state.policy);
export const getScheduleCallBackData = (state) =>
  fromPolicy.getScheduleCallBackData(state.policy);
export const getScheduleCallBackStatus = (state) =>
  fromPolicy.getScheduleCallBackStatus(state.policy);

export const getDisabledTimeListsLoading = (state) =>
  fromPolicy.getDisabledTimeListsLoading(state.policy);
export const getDisabledTimeListsData = (state) =>
  fromPolicy.getDisabledTimeListsData(state.policy);
export const getDisabledTimeListsStatus = (state) =>
  fromPolicy.getDisabledTimeListsStatus(state.policy);

export const createAppointmentLoading = (state) =>
  fromPolicy.createAppointmentLoading(state.policy);
export const createAppointmentData = (state) =>
  fromPolicy.createAppointmentData(state.policy);
export const createAppointmentStatus = (state) =>
  fromPolicy.createAppointmentStatus(state.policy);

//getChatReplyStatus
export const getChatReplyStatusLoading = (state) =>
  fromPolicy.getChatReplyStatusLoading(state.policy);
export const getChatReplyStatusData = (state) =>
  fromPolicy.getChatReplyStatusData(state.policy);
export const getChatReplyStatusStatus = (state) =>
  fromPolicy.getChatReplyStatusStatus(state.policy);

//connect live chat
export const connectLiveChatLoading = (state) =>
  fromPolicy.connectLiveChatLoading(state.policy);
export const connectLiveChatData = (state) =>
  fromPolicy.connectLiveChatData(state.policy);
export const connectLiveChatStatus = (state) =>
  fromPolicy.connectLiveChatStatus(state.policy);

//profile
export const getProfileLoading = (state) =>
  fromPolicy.getProfileLoading(state.policy);
export const getProfile = (state) => fromPolicy.getProfile(state.policy);

//get insider client info
export const getInsiderClientInfoReqLoading = (state) =>
  fromPolicy.getInsiderClientInfoReqLoading(state.policy);
export const getInsiderClientInfoReqStatus = (state) =>
  fromPolicy.getInsiderClientInfoReqStatus(state.policy);
export const getInsiderClientInfoReqData = (state) =>
  fromPolicy.getInsiderClientInfoReqData(state.policy);

//singtelPartnershipLeads
export const singtelPartnershipLeadsReqLoading = (state) =>
  fromPolicy.singtelPartnershipLeadsReqLoading(state.policy);
export const singtelPartnershipLeadsReqStatus = (state) =>
  fromPolicy.singtelPartnershipLeadsReqStatus(state.policy);
export const singtelPartnershipLeadsReqData = (state) =>
  fromPolicy.singtelPartnershipLeadsReqData(state.policy);

//auth
export const getLoginLoading = (state) => fromAuth.getLoginLoading(state.auth);
export const getLoginData = (state) => fromAuth.getLoginData(state.auth);
export const getLoginStatus = (state) => fromAuth.getLoginStatus(state.auth);
export const getConfirmLoginData = (state) =>
  fromAuth.getConfirmLoginData(state.auth);
export const getConfirmLoginLoading = (state) =>
  fromAuth.getConfirmLoginLoading(state.auth);
export const getConfirmLoginStatus = (state) =>
  fromAuth.getConfirmLoginStatus(state.auth);
// export const getAuthToken = (state) => fromAuth.getAuthToken(state.auth);
export const getForgotUserIdLoading = (state) =>
  fromAuth.getForgotUserIdLoading(state.auth);
export const getForgotUserIdData = (state) =>
  fromAuth.getForgotUserIdData(state.auth);
export const getForgotUserIdStatus = (state) =>
  fromAuth.getForgotUserIdStatus(state.auth);
export const getCurrentUserIdLoading = (state) =>
  fromAuth.getCurrentUserIdLoading(state.auth);
export const getCurrentUserIdData = (state) =>
  fromAuth.getCurrentUserIdData(state.auth);
export const getCurrentUserIdStatus = (state) =>
  fromAuth.getCurrentUserIdStatus(state.auth);
export const resendOtpLoading = (state) =>
  fromAuth.resendOtpLoading(state.auth);
export const resendOtpData = (state) => fromAuth.resendOtpData(state.auth);
export const resendOtpStatus = (state) => fromAuth.resendOtpStatus(state.auth);
export const forgotPasswordReqLoading = (state) =>
  fromAuth.forgotPasswordReqLoading(state.auth);
export const forgotPasswordReqData = (state) =>
  fromAuth.forgotPasswordReqData(state.auth);
export const forgotPasswordReqStatus = (state) =>
  fromAuth.forgotPasswordReqStatus(state.auth);
export const verifyForgotPassOtpLoading = (state) =>
  fromAuth.verifyForgotPassOtpLoading(state.auth);
export const verifyForgotPassOtpData = (state) =>
  fromAuth.verifyForgotPassOtpData(state.auth);
export const verifyForgotPassOtpStatus = (state) =>
  fromAuth.verifyForgotPassOtpStatus(state.auth);
export const changePasswordLoading = (state) =>
  fromAuth.changePasswordLoading(state.auth);
export const changePasswordData = (state) =>
  fromAuth.changePasswordData(state.auth);
export const changePasswordStatus = (state) =>
  fromAuth.changePasswordStatus(state.auth);
export const loginPortalLoading = (state) =>
  fromAuth.loginPortalLoading(state.auth);
export const loginPortalData = (state) => fromAuth.loginPortalData(state.auth);
export const loginPortalStatus = (state) =>
  fromAuth.loginPortalStatus(state.auth);
export const getAuthorizationAuthLoading = (state) =>
  fromAuth.getAuthorizationAuthLoading(state.auth);
export const getAuthorizationAuthData = (state) =>
  fromAuth.getAuthorizationAuthData(state.auth);
export const getAuthorizationAuthStatus = (state) =>
  fromAuth.getAuthorizationAuthStatus(state.auth);
export const getAuthTokenLoading = (state) =>
  fromAuth.getAuthTokenLoading(state.auth);
export const getAuthTokenData = (state) =>
  fromAuth.getAuthTokenData(state.auth);
export const getAuthTokenStatus = (state) =>
  fromAuth.getAuthTokenStatus(state.auth);
export const getSingPassLoading = (state) =>
  fromAuth.getSingPassLoading(state.auth);
export const getSingPassData = (state) => fromAuth.getSingPassData(state.auth);
export const getSingPassStatus = (state) =>
  fromAuth.getSingPassStatus(state.auth);

export const getMaintenanceMsgLoading = (state) =>
  fromAuth.getMaintenanceMsgLoading(state.auth);
export const getMaintenanceMsgData = (state) =>
  fromAuth.getMaintenanceMsgData(state.auth);
export const getMaintenanceMsgStatus = (state) =>
  fromAuth.getMaintenanceMsgStatus(state.auth);

export const generateLoginOtpLoading = (state) =>
  fromAuth.generateLoginOtpLoading(state.auth);
export const generateLoginOtpStatus = (state) =>
  fromAuth.generateLoginOtpStatus(state.auth);
export const generateLoginOtpData = (state) =>
  fromAuth.generateLoginOtpData(state.auth);

//Registration
export const registrationReqLoading = (state) =>
  fromRegistration.registrationReqLoading(state.registration);
export const registrationReqData = (state) =>
  fromRegistration.registrationReqData(state.registration);
export const registrationReqStatus = (state) =>
  fromRegistration.registrationReqStatus(state.registration);
//Registration Otp Request
export const registrationOTPReqLoading = (state) =>
  fromRegistration.registrationOTPReqLoading(state.registration);
export const registrationOTPReqData = (state) =>
  fromRegistration.registrationOTPReqData(state.registration);
export const registrationOTPReqStatus = (state) =>
  fromRegistration.registrationOTPReqStatus(state.registration);
//Registration Otp Verify
export const registrationOTPVerifyLoading = (state) =>
  fromRegistration.registrationOTPVerifyLoading(state.registration);
export const registrationOTPVerifyData = (state) =>
  fromRegistration.registrationOTPVerifyData(state.registration);
export const registrationOTPVerifyStatus = (state) =>
  fromRegistration.registrationOTPVerifyStatus(state.registration);
//Activation Generic Link Req
export const activationGenericLinkReqLoading = (state) =>
  fromRegistration.activationGenericLinkReqLoading(state.registration);
export const activationGenericLinkReqData = (state) =>
  fromRegistration.activationGenericLinkReqData(state.registration);
export const activationGenericLinkReqStatus = (state) =>
  fromRegistration.activationGenericLinkReqStatus(state.registration);
//Activation Generic Link OTP Verify
export const activationGenericOtpVerifyLoading = (state) =>
  fromRegistration.activationGenericOtpVerifyLoading(state.registration);
export const activationGenericOtpVerifyData = (state) =>
  fromRegistration.activationGenericOtpVerifyData(state.registration);
export const activationGenericOtpVerifyStatus = (state) =>
  fromRegistration.activationGenericOtpVerifyStatus(state.registration);
//Activation Personal Link Req
export const activationPersonalLinkReqLoading = (state) =>
  fromRegistration.activationPersonalLinkReqLoading(state.registration);
export const activationPersonalLinkReqData = (state) =>
  fromRegistration.activationPersonalLinkReqData(state.registration);
export const activationPersonalLinkReqStatus = (state) =>
  fromRegistration.activationPersonalLinkReqStatus(state.registration);
//Activate Personal Req
export const activatePersonalReqLoading = (state) =>
  fromRegistration.activatePersonalReqLoading(state.registration);
export const activatePersonalReqData = (state) =>
  fromRegistration.activatePersonalReqData(state.registration);
export const activatePersonalReqStatus = (state) =>
  fromRegistration.activatePersonalReqStatus(state.registration);

//Prompt Mobile Phone Input
export const promptMobilePhoneInputLoading = (state) =>
  fromRegistration.promptMobilePhoneInputLoading(state.registration);
export const promptMobilePhoneInputData = (state) =>
  fromRegistration.promptMobilePhoneInputData(state.registration);
export const promptMobilePhoneInputStatus = (state) =>
  fromRegistration.promptMobilePhoneInputStatus(state.registration);

//Prompt Mobile Phone Input
export const updateClientInfoLoading = (state) =>
  fromRegistration.updateClientInfoLoading(state.registration);
export const updateClientInfoData = (state) =>
  fromRegistration.updateClientInfoData(state.registration);
export const updateClientInfoStatus = (state) =>
  fromRegistration.updateClientInfoStatus(state.registration);

//Validate Movie Reg
export const validateMovieRegLoading = (state) =>
  fromRegistration.validateMovieRegLoading(state.registration);
export const validateMovieRegData = (state) =>
  fromRegistration.validateMovieRegData(state.registration);
export const validateMovieRegStatus = (state) =>
  fromRegistration.validateMovieRegStatus(state.registration);
//Submit Movie Reg
export const submitMovieRegLoading = (state) =>
  fromRegistration.submitMovieRegLoading(state.registration);
export const submitMovieRegData = (state) =>
  fromRegistration.submitMovieRegData(state.registration);
export const submitMovieRegStatus = (state) =>
  fromRegistration.submitMovieRegStatus(state.registration);

export const getRegistrationCustomerDetailsLoading = (state) =>
  fromRegistration.getRegistrationCustomerDetailsLoading(state.registration);
export const getRegistrationCustomerDetailsData = (state) =>
  fromRegistration.getRegistrationCustomerDetailsData(state.registration);
export const getRegistrationCustomerDetailsStatus = (state) =>
  fromRegistration.getRegistrationCustomerDetailsStatus(state.registration);

export const registerNewCustomerLoading = (state) =>
  fromRegistration.registerNewCustomerLoading(state.registration);
export const registerNewCustomerData = (state) =>
  fromRegistration.registerNewCustomerData(state.registration);
export const registerNewCustomerStatus = (state) =>
  fromRegistration.registerNewCustomerStatus(state.registration);

//Registration Otp Resend
export const registrationOtpResendLoading = (state) =>
  fromRegistration.registrationOtpResendLoading(state.registration);
export const registrationOtpResendData = (state) =>
  fromRegistration.registrationOtpResendData(state.registration);
export const registrationOtpResendStatus = (state) =>
  fromRegistration.registrationOtpResendStatus(state.registration);

//Check Renewability
export const checkRenewabilityLoading = (state) =>
  fromOnlineRenewal.checkRenewabilityLoading(state.onlineRenewalReq);
export const checkRenewabilityData = (state) =>
  fromOnlineRenewal.checkRenewabilityData(state.onlineRenewalReq);
export const checkRenewabilityStatus = (state) =>
  fromOnlineRenewal.checkRenewabilityStatus(state.onlineRenewalReq);

//Renewal PayNow
export const renewalPayNowLoading = (state) =>
  fromOnlineRenewal.renewalPayNowLoading(state.onlineRenewalReq);
export const renewalPayNowData = (state) =>
  fromOnlineRenewal.renewalPayNowData(state.onlineRenewalReq);
export const renewalPayNowStatus = (state) =>
  fromOnlineRenewal.renewalPayNowStatus(state.onlineRenewalReq);

//Renewal Get Status Message
export const getStatusMsgLoading = (state) =>
  fromOnlineRenewal.getStatusMsgLoading(state.onlineRenewalReq);
export const getStatusMsgData = (state) =>
  fromOnlineRenewal.getStatusMsgData(state.onlineRenewalReq);
export const getStatusMsgStatus = (state) =>
  fromOnlineRenewal.getStatusMsgStatus(state.onlineRenewalReq);

//Renewal Tiq Home
export const renewalTiqHomeLoading = (state) =>
  fromOnlineRenewal.renewalTiqHomeLoading(state.onlineRenewalReq);
export const renewalTiqHomeData = (state) =>
  fromOnlineRenewal.renewalTiqHomeData(state.onlineRenewalReq);
export const renewalTiqHomeStatus = (state) =>
  fromOnlineRenewal.renewalTiqHomeStatus(state.onlineRenewalReq);

//get DDA policy
export const getDDAPolicyLoading = (state) =>
  fromEnrolGIRONow.getDDAPolicyLoading(state.enrolGIRONow);
export const getDDAPolicyData = (state) =>
  fromEnrolGIRONow.getDDAPolicyData(state.enrolGIRONow);
export const getDDAPolicyStatus = (state) =>
  fromEnrolGIRONow.getDDAPolicyStatus(state.enrolGIRONow);

//create EDDA
export const createEDDALoading = (state) =>
  fromEnrolGIRONow.createEDDALoading(state.enrolGIRONow);
export const createEDDAData = (state) =>
  fromEnrolGIRONow.createEDDAData(state.enrolGIRONow);
export const createEDDAStatus = (state) =>
  fromEnrolGIRONow.createEDDAStatus(state.enrolGIRONow);

//create EDDA
export const getGIROBankListLoading = (state) =>
  fromEnrolGIRONow.getGIROBankListLoading(state.enrolGIRONow);
export const getGIROBankListData = (state) =>
  fromEnrolGIRONow.getGIROBankListData(state.enrolGIRONow);
export const getGIROBankListStatus = (state) =>
  fromEnrolGIRONow.getGIROBankListStatus(state.enrolGIRONow);

//Get GIRO CALL BACK DATA
export const getGiroCallBackDataLoading = (state) =>
  fromEnrolGIRONow.getGiroCallBackDataLoading(state.enrolGIRONow);
export const getGiroCallBackData = (state) =>
  fromEnrolGIRONow.getGiroCallBackData(state.enrolGIRONow);
export const getGiroCallBackDataStatus = (state) =>
  fromEnrolGIRONow.getGiroCallBackDataStatus(state.enrolGIRONow);

//Get GIRO CALL BACK exist
export const getGiroCallBackExistLoading = (state) =>
  fromEnrolGIRONow.getGiroCallBackExistLoading(state.enrolGIRONow);
export const getGiroCallBackExistData = (state) =>
  fromEnrolGIRONow.getGiroCallBackExistData(state.enrolGIRONow);
export const getGiroCallBackExistStatus = (state) =>
  fromEnrolGIRONow.getGiroCallBackExistStatus(state.enrolGIRONow);

//submit giro
export const submitGiroLoading = (state) =>
  fromEnrolGIRONow.submitGiroLoading(state.enrolGIRONow);
export const submitGiroData = (state) =>
  fromEnrolGIRONow.submitGiroData(state.enrolGIRONow);
export const submitGiroStatus = (state) =>
  fromEnrolGIRONow.submitGiroStatus(state.enrolGIRONow);

//Get GIRO Submit CALL BACK exist
export const getGiroSubmitCallBackExistLoading = (state) =>
  fromEnrolGIRONow.getGiroSubmitCallBackExistLoading(state.enrolGIRONow);
export const getGiroSubmitCallBackExistData = (state) =>
  fromEnrolGIRONow.getGiroSubmitCallBackExistData(state.enrolGIRONow);
export const getGiroSubmitCallBackExistStatus = (state) =>
  fromEnrolGIRONow.getGiroSubmitCallBackExistStatus(state.enrolGIRONow);

//enrol egiro
export const enroleGiroLoading = (state) =>
  fromEnrolGIRONow.enroleGiroLoading(state.enrolGIRONow);
export const enroleGiroData = (state) =>
  fromEnrolGIRONow.enroleGiroData(state.enrolGIRONow);
export const enroleGiroStatus = (state) =>
  fromEnrolGIRONow.enroleGiroStatus(state.enrolGIRONow);

//Confirm Pay EDDA GI ReNEWAL
export const confirmPayEddaGiRenewalLoading = (state) =>
  fromEnrolGIRONow.confirmPayEddaGiRenewalLoading(state.enrolGIRONow);
export const confirmPayEddaGiRenewalData = (state) =>
  fromEnrolGIRONow.confirmPayEddaGiRenewalData(state.enrolGIRONow);
export const confirmPayEddaGiRenewalStatus = (state) =>
  fromEnrolGIRONow.confirmPayEddaGiRenewalStatus(state.enrolGIRONow);

//get Twilio get file status
export const getTwilioGetFileStatusLoading = (state) =>
  fromTwilio.getTwilioGetFileStatusLoading(state.twilio);
export const getTwilioGetFileStatusData = (state) =>
  fromTwilio.getTwilioGetFileStatusData(state.twilio);
export const getTwilioGetFileStatusStatus = (state) =>
  fromTwilio.getTwilioGetFileStatusStatus(state.twilio);

//get Twilio OTP
export const getTwilioRequestOTPLoading = (state) =>
  fromTwilio.getTwilioRequestOTPLoading(state.twilio);
export const getTwilioRequestOTPData = (state) =>
  fromTwilio.getTwilioRequestOTPData(state.twilio);
export const getTwilioRequestOTPStatus = (state) =>
  fromTwilio.getTwilioRequestOTPStatus(state.twilio);

//get Twilio Get File
export const getTwilioGetFileLoading = (state) =>
  fromTwilio.getTwilioGetFileLoading(state.twilio);
export const getTwilioGetFileData = (state) =>
  fromTwilio.getTwilioGetFileData(state.twilio);
export const getTwilioGetFileStatus = (state) =>
  fromTwilio.getTwilioGetFileStatus(state.twilio);

//submitCampaignForm
export const submitCampaignFormReqLoading = (state) =>
  fromRegistration.submitCampaignFormReqLoading(state.registration);
export const submitCampaignFormReqStatus = (state) =>
  fromRegistration.submitCampaignFormReqStatus(state.registration);
export const submitCampaignFormReqData = (state) =>
  fromRegistration.submitCampaignFormReqData(state.registration);

//calculateWalkWagAmount
export const calculateWalkWagAmountReqLoading = (state) =>
  fromRegistration.calculateWalkWagAmountReqLoading(state.registration);
export const calculateWalkWagAmountReqStatus = (state) =>
  fromRegistration.calculateWalkWagAmountReqStatus(state.registration);
export const calculateWalkWagAmountReqData = (state) =>
  fromRegistration.calculateWalkWagAmountReqData(state.registration);

//checkPayNowQRStatus
export const checkPayNowQRStatusReqLoading = (state) =>
  fromRegistration.checkPayNowQRStatusReqLoading(state.registration);
export const checkPayNowQRStatusReqStatus = (state) =>
  fromRegistration.checkPayNowQRStatusReqStatus(state.registration);
export const checkPayNowQRStatusReqData = (state) =>
  fromRegistration.checkPayNowQRStatusReqData(state.registration);

//revamp 2.0
export const getRegistrationCustomerInfoLoading = (state) =>
  fromRegistration.getRegistrationCustomerInfoLoading(state.registration);
export const getRegistrationCustomerInfoStatus = (state) =>
  fromRegistration.getRegistrationCustomerInfoStatus(state.registration);
export const getRegistrationCustomerInfoData = (state) =>
  fromRegistration.getRegistrationCustomerInfoData(state.registration);

export const getLoginTokenLoading = (state) =>
  fromRegistration.getLoginTokenLoading(state.registration);
export const getLoginTokenStatus = (state) =>
  fromRegistration.getLoginTokenStatus(state.registration);
export const getLoginTokenData = (state) =>
  fromRegistration.getLoginTokenData(state.registration);

export const generateOTPOnboardingLoading = (state) =>
  fromRegistration.generateOTPOnboardingLoading(state.registration);
export const generateOTPOnboardingStatus = (state) =>
  fromRegistration.generateOTPOnboardingStatus(state.registration);
export const generateOTPOnboardingData = (state) =>
  fromRegistration.generateOTPOnboardingData(state.registration);

export const registerNewCustomerv2Loading = (state) =>
  fromRegistration.registerNewCustomerv2Loading(state.registration);
export const registerNewCustomerv2Status = (state) =>
  fromRegistration.registerNewCustomerv2Status(state.registration);
export const registerNewCustomerv2Data = (state) =>
  fromRegistration.registerNewCustomerv2Data(state.registration);

export const logRegistrationRequestLoading = (state) =>
  fromRegistration.logRegistrationRequestLoading(state.registration);
export const logRegistrationRequestStatus = (state) =>
  fromRegistration.logRegistrationRequestStatus(state.registration);
export const logRegistrationRequestData = (state) =>
  fromRegistration.logRegistrationRequestData(state.registration);

export const validateRegistrationLoading = (state) =>
  fromRegistration.validateRegistrationLoading(state.registration);
export const validateRegistrationStatus = (state) =>
  fromRegistration.validateRegistrationStatus(state.registration);
export const validateRegistrationData = (state) =>
  fromRegistration.validateRegistrationData(state.registration);

export const uploadOcrNricLoading = (state) =>
  fromRegistration.uploadOcrNricLoading(state.registration);
export const uploadOcrNrictStatus = (state) =>
  fromRegistration.uploadOcrNrictStatus(state.registration);
export const uploadOcrNricData = (state) =>
  fromRegistration.uploadOcrNricData(state.registration);

export const updateClientInfov4RequestLoading = (state) =>
  fromRegistration.updateClientInfov4RequestLoading(state.registration);
export const updateClientInfov4RequestStatus = (state) =>
  fromRegistration.updateClientInfov4RequestStatus(state.registration);
export const updateClientInfov4RequestData = (state) =>
  fromRegistration.updateClientInfov4RequestData(state.registration);